/**
 * debug-mode.guard.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { BuildFlags } from "../configuration/build-flags";

/**
 * The debug mode guard only allows access when the app is in debug mode.
 */
@Injectable()
export class DebugModeGuard implements CanActivate {
  public canActivate () : boolean
  {
    // Allow activation if the debug mode flag is set, otherwise not.
    return BuildFlags.debugMode;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/routing/debug-mode.guard.ts